import React from 'react';

interface FloatingBackgroundProps {
  numPoints?: number;
  numLines?: number;
  className?: string;
}

const FloatingBackground: React.FC<FloatingBackgroundProps> = ({ 
  numPoints = 8, 
  numLines = 5,
  className = ''
}) => {
  return (
    <div className={`floating-bg-elements ${className}`}>
      <div className="floating-points">
        {Array.from({ length: numPoints }, (_, i) => (
          <div key={i} className="floating-point"></div>
        ))}
      </div>
      <div className="floating-lines">
        {Array.from({ length: numLines }, (_, i) => (
          <div key={i} className="floating-line"></div>
        ))}
      </div>
    </div>
  );
};

export default FloatingBackground;
